import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout de /admin/clientes/* — index (lista) e $id (detalhe) renderizam
 * dentro do Outlet.
 */
export const Route = createFileRoute('/admin/clientes')({
  component: () => <Outlet />,
});
